export const ITEMS_PER_PAGE = 25;
export const MAX_TAKE_ITEMS = 1000;
export const ITEMS_PER_PAGE_OPTIONS = [
  { value: 25 },
  { value: 50 },
  { value: 100 },
];
